import { isValidLocationCoordinates } from '~/shared-kernel/domain/location'

/** Google Maps chooses the origin; no browser geolocation permission is needed here. */
export function eventLocationDirectionsUrl(location: unknown): string | null {
  if (!isValidLocationCoordinates(location)) return null
  const url = new URL('https://www.google.com/maps/dir/')
  url.searchParams.set('api', '1')
  url.searchParams.set('destination', `${location.latitude},${location.longitude}`)
  return url.toString()
}
